import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  isLogin: null,
  user: {},
  themeColor: "#ED73AA",
  fontFamily: "'Poppins', sans-serif",
  emailnotification: 0,

  getStaff: [],
  getlogs: [],
  getDealerDashboard: null,
  isReset: false,
};

const AuthReducer = (state = initialState, action) => {
  // console.log("statee", state);

  switch (action.type) {
    case ActionTypes.IsLogin:
      state = { ...state, isLogin: action.payload };
      break;

    case ActionTypes.IsReset:
      state = { ...state, isReset: action.payload };
      break;

    case ActionTypes.GET_USER:
      state = { ...state, user: action.payload };
      break;

    case ActionTypes.EmailNotification:
      state = { ...state, emailnotification: action.payload };
      break;

    case ActionTypes.GET_STAFF:
      state = { ...state, getStaff: action.payload };
      break;

    case ActionTypes.RESET_STAFF:
      state = { ...state, getStaff: [] };
      break;

    case ActionTypes.IsLogout:
      state = { user: null, isLogin: false };
      break;

    // case ActionTypes.ChangeThemeColor:
    //   state = { ...state, themeColor: action.payload };
    //   break;
    // case ActionTypes.ChangeThemeFont:
    //   state = { ...state, fontFamily: action.payload };
    //   break;

    case ActionTypes.UpdateUserProfile:
      state = { ...state, user: { ...state.user, user: action.payload } };
      break;

    case ActionTypes.GET_DEALER_DASHBOARD:
      state = { ...state, getDealerDashboard: action.payload };
      break;

    case ActionTypes.LOGS:
      state = { ...state, getlogs: action.payload };
      break;
    // case ActionTypes.NotificationSwitch:
    //   state = {
    //     ...state,
    //     user: { ...state.user, is_receive_notification: action.payload },
    //   };
    //   localStorage.setItem("@user", JSON.stringify(state.user));
    //   break;

    default:
      break;
  }
  return state;
};

export default AuthReducer;
